// Axion Elite — Marquee speed calibration
// CSS animation handles the scroll; JS measures each marquee's inner width
// and updates --marquee-duration so speed stays constant at any screen
// size. A page can have more than one marquee instance (e.g. the home
// marquee section plus the footer ticker), so every .marquee-inner on the
// page is calibrated independently.

(function () {
  var SPEED = 100; // px per second

  function calibrate() {
    var inners = document.querySelectorAll('.marquee-inner');
    inners.forEach(function (inner) {
      var halfWidth = inner.scrollWidth / 2;
      var duration = halfWidth / SPEED;
      inner.style.setProperty('animation-duration', duration + 's');
    });
  }

  function init() {
    calibrate();
    window.addEventListener('resize', calibrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
